// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D4Qs","newExpiryDate":"styles_newExpiryDate__Azpng","footer":"styles_footer__3XAu1"};